import { View } from 'lucide-react';

import { definePanel } from '@/app/definePanel';

export default definePanel({
    id: 'rule_estimate',
    title: 'Event preview',
    icon: View,
    // A non-filling drawer to the right of the rule editor, as wide as its pictures need.
    width: { min: 312, default: 312, max: 480, fill: false },
    modes: ['settings'],
    themes: 'any',
    // Right of the combined Rules panel; where the row has no room for it, it floats over it.
    order: 4.5,
    isOverlay: true,
    // It shows the selected event card, so it wears that card's surface.
    hasSelectedSurface: true,
    // Each section draws its own header row.
    isHeaderless: true,
    // Opened by selecting an event card or its Preview button, not a rail button.
    hasNavButton: false,
    // Mutual exclusions live in src/app/exclusions.ts (shares the rules clique).
    // ruleId mirrors the combined Rules panel's selection; it stays in the local props.
    urlSyncedProps: [],
});
